import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'waste_water_treatment_proficiency'

export const dataPointDefinition = {
  retracedId: 'waste_water_treatment_proficiency',
  name: 'How do you treat your wastewater and what is the annual volume?',
  meta: {
    isMultipleRow: true,
    columns: [
      {
        key: 1,
        name: 'Wastewater Type',
        type: 'SELECT',
        id: 'waste_water_type',
        options: [
          {
            key: 'HAZARDOUS_WASTEWATER',
            text: 'Hazardous wastewater',
          },
          {
            key: 'NON-HAZARDOUS_WASTEWATER',
            text: 'Non-hazardous wastewater',
          },
          {
            key: 'UNKNOWN',
            text: 'Unknown',
          },
        ],
      },
      {
        key: 2,
        name: 'Wastewater Treatment',
        type: 'SELECT',
        id: 'waste_water_treatment',
        options: [
          {
            key: 'BOTH_ONSITE_OFFSITE_TREATMENT',
            text: 'Both on-site and off-site treatment',
          },
          {
            key: 'MUNICIPAL/PUBLIC_SEWER_SYSTEMS',
            text: 'Municipal/public sewer systems',
          },
          {
            key: 'NO_TREATMENT',
            text: 'No Treatment',
          },
          {
            key: 'OFF-SITE_WATER_TREATMENT',
            text: 'Off-site water treat ment',
          },
          {
            key: 'ON-SITE_PARTIAL_RECLAMATION',
            text: 'On-site partial reclamation',
          },
          {
            key: 'ON-SITE_WATERSHED_MANAGEMENT',
            text: 'On-site watershed management',
          },
          {
            key: "REUSE/RECYCLE_IN_ORGANIZATION'S_OWN_OPERATIONS",
            text: "Reuse/recycle in organization's own operations",
          },
          {
            key: 'UNKNOWN',
            text: 'Unknown',
          },
          {
            key: 'ZERO_LIQUID_DISCHARGE',
            text: 'Zero Liquid Discharge',
          },
        ],
      },
      {
        key: 3,
        name: 'Treatment Efficiency',
        type: 'SELECT',
        id: 'treatment_efficiency',
        options: [
          {
            key: 'AVERAGE_TREATMENT_EFFICIENCY',
            text: 'Average treatment Efficiency',
          },
          {
            key: 'HIGH_TREATMENT_EFFICIENCY',
            text: 'High treatment Efficiency',
          },
          {
            key: 'NO_TREATMENT/LOW_EFFICIENCY',
            text: 'No Treatment/low efficiency',
          },
        ],
      },
      {
        key: 4,
        name: 'Total annual volume',
        type: 'NUMBER_UOM',
        unit: 'CUBIC_METRE',
        id: 'total_annual_volume',
        unitText: 'm³',
      },
      {
        key: 5,
        name: 'Contamination Level in mg/l',
        type: 'NUMBER',
        id: 'contamination_level',
      },
      {
        key: 6,
        name: 'Year',
        type: 'SELECT_YEAR',
        id: 'year',
      },
    ],
  },
  fieldTypeId: 'TABLE',
  type: 'RELATIONAL',
  options: [
    {
      wasteWater: [
        {
          key: 'HAZARDOUS_WASTEWATER',
          text: 'Hazardous wastewater',
        },
        {
          key: 'NON-HAZARDOUS_WASTEWATER',
          text: 'Non-hazardous wastewater',
        },
        {
          key: 'UNKNOWN',
          text: 'Unknown',
        },
      ],
    },
    {
      wasteWaterTreatment: [
        {
          key: 'BOTH_ONSITE_OFFSITE_TREATMENT',
          text: 'Both on-site and off-site treatment',
        },
        {
          key: 'MUNICIPAL/PUBLIC_SEWER_SYSTEMS',
          text: 'Municipal/public sewer systems',
        },
        {
          key: 'NO_TREATMENT',
          text: 'No Treatment',
        },
        {
          key: 'OFF-SITE_WATER_TREATMENT',
          text: 'Off-site water treatment',
        },
        {
          key: 'ON-SITE_PARTIAL_RECLAMATION',
          text: 'On-site partial reclamation',
        },
        {
          key: 'ON-SITE_WATERSHED_MANAGEMENT',
          text: 'On-site watershed management',
        },
        {
          key: "REUSE/RECYCLE_IN_ORGANIZATION'S_OWN_OPERATIONS",
          text: "Reuse/recycle in organization's own operations",
        },
        {
          key: 'UNKNOWN',
          text: 'Unknown',
        },
        {
          key: 'ZERO_LIQUID_DISCHARGE',
          text: 'Zero Liquid Discharge',
        },
      ],
    },
    {
      treatmentEfficiency: [
        {
          key: 'AVERAGE_TREATMENT_EFFICIENCY',
          text: 'Average treatment efficiency',
        },
        {
          key: 'HIGH_TREATMENT_EFFICIENCY',
          text: 'High treatment efficiency',
        },
        {
          key: 'NO_TREATMENT/LOW_EFFICIENCY',
          text: 'No Treatment/low efficiency',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            wasteWaterType: {
              type: 'string',
              enum: ['HAZARDOUS_WASTEWATER', 'NON-HAZARDOUS_WASTEWATER', 'UNKNOWN'],
            },
            wastewaterTreatment: {
              type: 'string',
              enum: [
                'BOTH_ONSITE_OFFSITE_TREATMENT',
                'MUNICIPAL/PUBLIC_SEWER_SYSTEMS',
                'NO_TREATMENT',
                'OFF-SITE_WATER_TREATMENT',
                'ON-SITE_PARTIAL_RECLAMATION',
                'ON-SITE_WATERSHED_MANAGEMENT',
                "REUSE/RECYCLE_IN_ORGANIZATION'S_OWN_OPERATIONS",
                'UNKNOWN',
                'ZERO_LIQUID_DISCHARGE',
              ],
            },
            treatmentEfficiency: {
              type: 'string',
              enum: ['AVERAGE_TREATMENT_EFFICIENCY', 'HIGH_TREATMENT_EFFICIENCY', 'NO_TREATMENT/LOW_EFFICIENCY'],
            },
            unit: {
              type: 'string',
              enum: ['CUBIC_METRE'],
            },
            totalAnnualVolume: {
              type: 'number',
            },
            contaminationLevel: {
              type: 'number',
            },
            year: {
              type: 'number',
              minimum: 1000,
              maximum: 9000,
            },
          },
          required: [
            'wasteWaterType',
            'wasteWaterTreatment',
            'treatmentEfficiency',
            'year',
            'unit',
            'totalAnnualVolume',
          ],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [],
  sortingId: 600,
  sectionId: '2.1.3.2',
  impactArea: 'Wastewater Management',
  impactAreaId: 'WASTEWATER_MANAGEMENT',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
